import { Box, themeGet } from 'react-components';
import styled from 'styled-components';

export const RichContentWrapper = styled(Box)`
  p {
    font-family: ${themeGet('fonts.body')};
    margin-top: 2rem;
    margin-bottom: 2rem;
  }

  li {
    margin-bottom: 1rem;
  }

  a {
    text-decoration: underline;
    word-wrap: break-word;
  }

  img {
    width: 100%;
    max-width: 25rem;
  }

  .block-img {
    text-align: center;
  }

  ul,
  ol {
    margin-inline-start: 2rem;
  }
`;
